import { ModelBase } from '../../core/model/model-base';
import { SmsStatus, SmsStatusToString } from './const/enums';

export class Sms extends ModelBase {
  constructor() {
    super();

    this.status = SmsStatus.Created;
  }

  private _createdDateTime: Date;
  private _deliveredDateTime: Date;
  private _sendDateTime: Date;

  phone: string;
  message: string;
  receiverName: string;

  get createdDateTime(): Date {
    return this._createdDateTime;
  }
  set createdDateTime(value: Date) {
    this._createdDateTime = this.coerceDate(value);
  }

  get deliveredDateTime(): Date {
    return this._deliveredDateTime;
  }
  set deliveredDateTime(value: Date) {
    this._deliveredDateTime = this.coerceDate(value);
  }

  get sendDateTime(): Date {
    return this._sendDateTime;
  }
  set sendDateTime(value: Date) {
    this._sendDateTime = this.coerceDate(value);
  }

  status: SmsStatus;

  get statusCaption(): string {
    return SmsStatusToString(this.status);
  }
}
